import type { GamePageContext } from "../../game-types";
import { getActualViewer } from "@/data/viewer";

type ViewerState = "signed-in" | "anonymous" | "unavailable";

export function viewerState({
  signal,
  game,
}: {
  signal?: AbortSignal | undefined;
  game: GamePageContext | null;
}): Promise<ViewerState> {
  if (game) {
    const signedIn =
      game.viewer?.subject_type === "user" && !!game.viewer.subject_id;
    return Promise.resolve(signedIn ? "signed-in" : "anonymous");
  }

  return getActualViewer({ signal }).then<ViewerState, ViewerState>(
    (viewer) =>
      viewer?.subject_type === "user" && viewer.subject_id
        ? "signed-in"
        : "anonymous",
    (error: unknown) => {
      signal?.throwIfAborted();
      console.error("Route session is unavailable", error);
      return "unavailable";
    },
  );
}
